import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './AppShell';
import { CalibrationPage } from '../pages/CalibrationPage';
import { DashboardPage } from '../pages/DashboardPage';
import { HistoryPage } from '../pages/HistoryPage';
import { MethodPage } from '../pages/MethodPage';
import { ResultsPage } from '../pages/ResultsPage';
import { SessionSetupPage } from '../pages/SessionSetupPage';
import { SettingsPage } from '../pages/SettingsPage';
import { TrainingPage } from '../pages/TrainingPage';
import { useApp } from './AppContext';

export function App() {
  const { ready, loadError, refresh } = useApp();
  if (!ready) {
    return <div className="app-loading" role="status"><span aria-hidden="true" /><strong>SCAN90 LAB</strong><small>記録を読み込んでいます</small></div>;
  }
  if (loadError) {
    return (
      <div className="app-loading" role="alert">
        <strong>端末内データの読込を停止しました</strong>
        <small>{loadError}</small>
        <button className="button" type="button" onClick={() => void refresh().catch(() => undefined)}>読込を再試行</button>
      </div>
    );
  }
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="calibration" element={<CalibrationPage />} />
        <Route path="session" element={<SessionSetupPage />} />
        <Route path="results/:sessionId" element={<ResultsPage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="method" element={<MethodPage />} />
      </Route>
      <Route path="train" element={<TrainingPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
